<mat-button-toggle-group
  hideSingleSelectionIndicator
  [value]="value()"
  [disabled]="disabled()"
  (change)="onSelect($event.value)"
>
  <!-- Material types aria-label as string but leaves the attribute off while it is undefined. -->
  @for (option of options(); track option.value) {
    <mat-button-toggle
      [value]="option.value"
      [aria-label]="option.ariaLabel!"
      [class.button-toggle--selected]="value() === option.value"
    >
      @if (option.icon) {
        <mat-icon class="button-toggle__icon">{{ option.icon }}</mat-icon>
      }
      {{ option.label }}
    </mat-button-toggle>
  }
</mat-button-toggle-group>
